import Vue from 'vue' ;
import {Message} from 'element-ui';
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame';
import home from '@/pages/home/index';
import login from '@/pages/login/index';

//用户管理
import user from '@/pages/user/frame';
import userList from '@/pages/user/list';
import userAdd from '@/pages/user/add';
import userDetail from '@/pages/user/detail';
import userEdit from '@/pages/user/edit';

//商品管理
import goods from '@/pages/goods/frame';
import goodsList from '@/pages/goods/list';
import goodsDetail from '@/pages/goods/detail';
import goodsAdd from '@/pages/goods/add';
import goodsEdit from '@/pages/goods/edit';

//库存管理
import stock from '@/pages/stock/frame';
import stockList from '@/pages/stock/list';
import stockEdit from '@/pages/stock/edit';

//账单管理
import bill from '@/pages/bill/frame';
import billList from '@/pages/bill/list';
import billDetail from '@/pages/bill/detail';
//订单管理
import order from '@/pages/order/frame';
// import orderList from '@/pages/order/list';
// import orderDetail from '@/pages/order/detail';
import liquidation from '@/pages/order/liquidation';

import lockList from '@/pages/order/list-lock';
import orderList from '@/pages/order/list-order';
import clearList from '@/pages/order/list-clear';
import lockDetail from '@/pages/order/detail-lock';
import orderDetail from '@/pages/order/detail-order';
import clearDetail from '@/pages/order/detail-clear';
import orderPrev from '@/pages/order/orderPrev';
import orderImport from '@/pages/order/orderImport';


//数据规则管理
import rule from '@/pages/rule/frame';
import ruleList from '@/pages/rule/list';
import explain from '@/pages/rule/explain';


//系统管理
import system from '@/pages/system/frame';//外层架子；
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';
//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:true,matchLeftKey:'/home'}
        },
        // {
        //   path: '/tag/index',
        //   name: 'tagIndex',
        //   component: tagIndex,
        //   meta:{title:'标签管理',isShowBread:true,matchLeftKey:'/tag'}
        // },

        {
          path: '/user',
          name: 'user',
          component: user,
          meta:{title:'用户管理'},
          children:[
            {
              path: 'list',
              name: 'userList',
              component: userList,
              meta:{title:'用户列表',isShowBread:true,matchLeftKey:'/user/list'}
            },
            {
              path: 'detail',
              name: 'userDetail',
              component: userDetail,
              meta:{title:'用户详情',isShowBack:false,isShowBread:false,matchLeftKey:'/user/detail'}
            },
            {
              path: 'edit',
              name: 'userEdit',
              component: userEdit,
              meta:{title:'用户编辑',isShowBack:true,isShowBread:true,matchLeftKey:'/user/edit'}
            },
            {
              path: 'add',
              name: 'userAdd',
              component: userAdd,
              meta:{title:'新增用户',isShowBack:true,isShowBread:true,matchLeftKey:'/user/add'}
            },
          ]
        },
        {
          path: '/goods',
          name: 'goods',
          component: goods,
          meta:{title:'商品管理'},
          children:[
            {
              path: 'list',
              name: 'goodsList',
              component: goodsList,
              meta:{title:'商品列表',isShowBread:false,matchLeftKey:'/goods/list'}
            },
            {
              path: 'detail',
              name: 'goodsDetail',
              component: goodsDetail,
              meta:{title:'商品详情',isShowBread:true,isShowBack:true,matchLeftKey:'/goods/detail'}
            },
            {
              path: 'add',
              name: 'goodsAdd',
              component: goodsAdd,
              meta: {title: '添加商品', isShowBread: true, isShowBack: true, matchLeftKey: '/goods/add'}
            },
            {
              path: 'edit',
              name: 'goodsEdit',
              component: goodsEdit,
              meta: {title: '编辑商品', isShowBread: true, isShowBack: true, matchLeftKey: '/goods/edit'}
            },
          ]
        },
        {
          path: '/stock',
          name: 'stock',
          component: stock,
          meta:{title:'库存管理'},
          children:[
            {
              path: 'list',
              name: 'stockList',
              component: stockList,
              meta:{title:'库存列表',isShowBread:false,matchLeftKey:'/stock/list'}
            },
            {
              path: 'edit',
              name: 'stockEdit',
              component: stockEdit,
              meta:{title:'库存修改', isShowBread:true, isShowBack:true, matchLeftKey:'/stock/edit'}
            }
          ]
        },
        {
          path: '/bill',
          name: 'bill',
          component: bill,
          meta:{title:'账单管理'},
          children:[
            {
              path: 'list',
              name: 'billList',
              component: billList,
              meta:{title:'账单列表',isShowBread:true,matchLeftKey:'/bill/list'}
            },
            {
              path: 'detail',
              name: 'billDetail',
              component: billDetail,
              meta:{title:'账单详情',isShowBread:true,matchLeftKey:'/bill/detail'}
            }
          ]
        },
        // 订单
        {
          path: '/order',
          name: 'order',
          component: order,
          meta:{title:'订单管理'},
          children:[
            {
              path: 'orderPrev',
              name: 'orderPrev',
              component: orderPrev,
              meta:{title:'订单预处理',isShowBread:false,matchLeftKey:'/order/orderPrev'}
            },
            {
              path: 'orderImport',
              name: 'orderImport',
              component: orderImport,
              meta:{title:'订单导入',isShowBread:false, matchLeftKey:'/order/orderImport'}
            },
            {
              path: 'lockList',
              name: 'lockList',
              component: lockList,
              meta:{title:'锁仓列表',isShowBread:false,matchLeftKey:'/order/lockList'}
            },
            {
              path: 'orderList',
              name: 'orderList',
              component: orderList,
              meta:{title:'下单列表',isShowBread:false,matchLeftKey:'/order/orderList'}
            },
            {
              path: 'clearList',
              name: 'clearList',
              component: clearList,
              meta:{title:'清算列表',isShowBread:false,matchLeftKey:'/order/clearList'}
            },
            {
              path: 'lockDetail',
              name: 'lockDetail',
              component: lockDetail,
              meta:{title:'锁仓详情',isShowBread:true,isShowBack:true,matchLeftKey:'/order/lockDetail'}
            },
            {
              path: 'orderDetail',
              name: 'orderDetail',
              component: orderDetail,
              meta:{title:'下单详情',isShowBread:true,isShowBack:true,matchLeftKey:'/order/orderDetail'}
            },
            {
              path: 'clearDetail',
              name: 'clearDetail',
              component: clearDetail,
              meta:{title:'清算详情',isShowBread:true,isShowBack:true,matchLeftKey:'/order/clearDetail'}
            },
          ]
        },
        // 规则管理
        {
          path: '/rule',
          name: 'rule',
          component: rule,
          meta:{title:'规则管理'},
          children:[
            {
              path: 'list',
              name: 'ruleList',
              component: ruleList,
              meta:{title:'数据规则',isShowBread:true,matchLeftKey:'/rule/list'}
            },
            {
              path: 'explain',
              name: 'explain',
              component: explain,
              meta:{title:'名词解释',isShowBread:true,matchLeftKey:'/rule/explain'}
            },

          ]
        },
        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        //系统管理
        {
          path:'/system',
          name:'system',
          component:system,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]

        }

      ]
    },
    // {
    //     path: '*',
    //     redirect: '/404'
    // },

  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
if(window.gtag){
  gtag('config', 'G-EL54PTR8RK', {'page_path': to.fullPath})
}
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "数字云仓管理平台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        // Message({
        //     message: "请先登录~",
        //     type: 'warning',
        //     duration: 1500
        // });
        setTimeout(function() {
            router.replace("/login")
        }, 100)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedSZHC")
    console.log("isLogined:"+isLogined)
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js